import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import FallbackErrorMessage from '../../../../utils/errors/FallbackMessage'
import { EInvoiceHistory } from '../components'

export const EInvoiceHistoryPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <EInvoiceHistory />
    </ErrorBoundary>
  )
}
